import { $createLinkNode } from '@lexical/link';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $createTextNode, $insertNodes, KEY_BACKSPACE_COMMAND } from 'lexical';
/**
 * This hook is used to insert a link into the editor.
 * @returns A function that inserts a link into the editor.
 * @param link - The URL of the link to insert.
 * @param label - The text to display for the link.
 */

export const useLinkInsertion = () => {
  const [editor] = useLexicalComposerContext();

  const insertLink = (link: string, label: string, keyPress?: KeyboardEvent) => {
    editor.update(() => {
      const linkNode = $createLinkNode(link);
      linkNode.append($createTextNode(label));
      $insertNodes([linkNode]);
    });
    // Dispatch this when the user presses the enter key because it's adding a new line when the link is inserted
    if (keyPress) editor.dispatchCommand(KEY_BACKSPACE_COMMAND, keyPress);
  };

  return insertLink;
};
